import React from 'react';
import styles from './Style.module.css';
import Skeleton from 'react-loading-skeleton';

const Loader = () => {
  const skeletonCount = 2;
  const skeletonArray = Array.from({ length: skeletonCount });

  return (
    <div className={styles.outletTypeOptionsSkeleton}>
      {skeletonArray.map((_, index) => (
        <React.Fragment key={index}>
          <div className={styles.outletTypeBtnSkeleton}>
            <Skeleton />
          </div>
          {index < skeletonArray.length - 1 && <hr className="line" />}
        </React.Fragment>
      ))}
    </div>
  );
};

export default Loader;
